import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";


// Get Table Data
export const STPEnergyAuditTableDataAPI = createAsyncThunk("STPEnergyAuditTableData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_UserID,
        Flag,
        token,
        From,
        To,
        handleSTPEnergyAuditExport
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_STP_T_STP_EnergyAudit_Select?M_WardID=${M_WardID ? M_WardID : '0'}&FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_UserID=${M_UserID}&From=${From}&To=${To}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleSTPEnergyAuditExport && handleSTPEnergyAuditExport()
                return result.data

            } else {
                return result
            }
        })
})

const STPEnergyAuditTableDataSlice = createSlice({
    name: "STPEnergyAuditTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPEnergyAuditTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(STPEnergyAuditTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(STPEnergyAuditTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const STPEnergyAuditTableDataReducer = STPEnergyAuditTableDataSlice.reducer

export const STPEnergyAuditTableExportDataAPI = createAsyncThunk("STPEnergyAuditTableExportData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_UserID,
        Flag,
        token,
        From,
        To,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_STP_T_STP_EnergyAudit_Select?M_WardID=${M_WardID ? M_WardID : '0'}&FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_UserID=${M_UserID}&From=${From}&To=${To}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data

            } else {
                return result
            }
        })
})

const STPEnergyAuditTableExportDataSlice = createSlice({
    name: "STPEnergyAuditTableExportData",
    initialState: {
        isExportLoading: false,
        ExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPEnergyAuditTableExportDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(STPEnergyAuditTableExportDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExportTableData = action.payload;
        });
        builder.addCase(STPEnergyAuditTableExportDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExportTableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const STPEnergyAuditTableExportDataReducer = STPEnergyAuditTableExportDataSlice.reducer


// export const ChlorineTableExportDataAPI = createAsyncThunk("ChlorineTableExportData", async ({ data }) => {
//     const {
//         FromDate,
//         ToDate,
//         M_WardID,
//         M_WS_JunctionID,
//         M_UserID,
//         token,
//         From,
//         To,
//         DashProjectTypeId,
//     } = data

//     var myHeaders = new Headers();
//     myHeaders.append("Authorization", "Bearer " + token);

//     var requestOptions = {
//         method: 'GET',
//         headers: myHeaders,
//         redirect: 'follow'
//     };

//     let url

//     if (DashProjectTypeId == '6') {
//         url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_Distri_WaterQualityChlorine_Select?FromDate=${FromDate ? FromDate :''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_Distri_WS_LocationID=${M_WS_JunctionID ? M_WS_JunctionID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}`
//     } else {
//         url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_WS_WaterQualityChlorine_Select?FromDate=${FromDate ? FromDate :''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WS_JunctionID=${M_WS_JunctionID ? M_WS_JunctionID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}`
//     }

//     return fetch(url, requestOptions)
//         .then((res) => res.json())
//         .then((result) => {
//             if (result.code >= 200 && result.code <= 300 && result.data) {
//                 return result.data
//             } else {
//                 return result
//             }
//         })
// })

// const ChlorineTableExportDataSlice = createSlice({
//     name: "ChlorineTableExportData",
//     initialState: {
//         isExportLoading: false,
//         ExportTableData: null,
//         isError: false,
//     },
//     extraReducers: (builder) => {
//         builder.addCase(ChlorineTableExportDataAPI.pending, (state, action) => {
//             state.isExportLoading = true;
//         });
//         builder.addCase(ChlorineTableExportDataAPI.fulfilled, (state, action) => {
//             state.isExportLoading = false;
//             state.ExportTableData = action.payload;
//         });
//         builder.addCase(ChlorineTableExportDataAPI.rejected, (state, action) => {
//             console.log("Error", action.payload);
//             state.isExportLoading = false;
//             state.isError = true;
//             state.ExportTableData = null;
//             toastErrorr('Something went wrong')
//         });
//     },
// })

// export const ChlorineTableExportDataReducer = ChlorineTableExportDataSlice.reducer



export const STPEnergyAuditPostDataAPI = createAsyncThunk("STPEnergyAuditPostData", async ({ data }) => {
    const {
        T_STP_EnergyAuditID,
        StipElectricConsumption,
        ConsumptionKWH,
        PowerFactor,
        PowerFactorIncentive,
        DemandPenalty,
        M_UserID,
        token,
        Flag,
        handleIsPost,
        handleClearField,
        handleOnCloseClick,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("T_STP_EnergyAuditID", T_STP_EnergyAuditID);
    formdata.append("StipElectricConsumption", StipElectricConsumption);
    formdata.append("ConsumptionKWH", ConsumptionKWH);
    formdata.append("PowerFactor", PowerFactor);
    formdata.append("PowerFactorIncentive", PowerFactorIncentive);
    formdata.append("DemandPenalty", DemandPenalty);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'PATCH',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

    fetch(`${BaseUrl}/APKDashboard/Post_WEB_STP_T_STP_EnergyAudit_Update`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                // handleClearField()
                handleOnCloseClick()
                toastSuccesss(result.message)
                return result.data
            } else {
                toastErrorr(result.message)
            }
            return result
        })
})


const STPEnergyAuditPostDataSlice = createSlice({
    name: "STPEnergyAuditPostData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPEnergyAuditPostDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(STPEnergyAuditPostDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(STPEnergyAuditPostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const STPEnergyAuditPostDataReducer = STPEnergyAuditPostDataSlice.reducer

// -----------------Delete API ---------------


export const STPEnergyAuditDeleteAPI = createAsyncThunk("STPEnergyAuditDelete", async ({ data }) => {
    const {
        T_STP_EnergyAuditID,
        M_UserID,
        token,
        handleIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);


    var formdata = new FormData();
    formdata.append("T_STP_EnergyAuditID", T_STP_EnergyAuditID);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/APKDashboard/WEB_STP_T_STP_EnergyAudit_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const STPEnergyAuditDeleteSlice = createSlice({
    name: "STPEnergyAuditDelete",
    initialState: {
        isDeleteLoading: false,
        SectorData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPEnergyAuditDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(STPEnergyAuditDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.SectorData = action.payload;

        });
        builder.addCase(STPEnergyAuditDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.SectorData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const STPEnergyAuditDeleteReducer = STPEnergyAuditDeleteSlice.reducer